angular.module('homebot.directives')

.directive('pmiSection', ['DataService', 'Dictionary', 'UtilService', 'PageNotificationService', 'LoanFormParser', 'RollbarService', function(DataService, Dictionary, utils, PageNotificationService, loanFormParser, RollbarService){

  return {
    restrict: 'AE',
    controllerAs: 'pmiCtrl',
    bindToController: {
      agent: '=',
      home: '=',
      homeValue: '@',
      userId: '@',
      onSave: '&'
    },
    scope: {},
    templateUrl: '/homes/templates/section-pmi.html',
    controller: function(){
      let ctrl = this;
      let dictionary = new Dictionary();

      var refresh = function () {
        ctrl.loan = loanFormParser.parseForEditing(ctrl.home.currentLoans[0]);
        ctrl.manualPMITotal = dictionary.conventionalPmiMonthlyTotal(ctrl.home);
        ctrl.estimatedPMITotal = dictionary.estimatedPmiMonthlyTotal(ctrl.home);
        ctrl.loading = false;
      }

      ctrl.refresh = refresh;

      refresh();

      utils.track(ctrl.manualPMITotal ? 'KnownPMILoaded' : 'EstPMILoaded');

      ctrl.lookup = function(prop){
        return dictionary[prop](ctrl.home);
      };

      ctrl.setPmi = function (value) {
        const loan = loanFormParser.parse(ctrl.loan);
        ctrl.loading = true;
        loan.pmi_monthly = value;

        DataService.saveLoan(loan, ctrl.loan.id)
          .then(function () {
            ctrl.onSave();
            ctrl.loading = false;
          })
          .catch(function (e) {
            PageNotificationService.error('There was an error saving your PMI.');
            RollbarService.error('Save PMI', e);
            ctrl.loading = false;
          })
      };
    },

    link: function ($scope, el, attrs, ctrl) {
      $scope.$watch('pmiCtrl.home.currentLoans', function () {
        ctrl.refresh();
      });
    }
  }
}]);
